import React, { Component } from 'react';
import {
    List,
    Row,
    Col,
} from 'antd';
import { Redirect } from 'react-router-dom';
import FormStepTitle from '../FormStepTitle';
import ServiceListItem from '../../booking/ServiceListItem';
import SERVICES_LIST from '../../../constants/servicesList';
import { withFormHandler } from '../../../containers/providers/CustomerBookingFormHandler';


class FormStepService extends Component {
    state = {
        hasError: false,
        buttonClicked: false,
    };

    onItemClick = item => {
        this.setState({ buttonClicked: true });

        this.props.submitStep(item);
    }
    render() {
        const { hasError } = this.state;

        if (hasError) {
            return <Redirect to="/404"/>;
        }

        return (
            <Row gutter={40}>
                <Col span={24}>
                    <FormStepTitle label="Select a window cleaning service" />
                    <List
                        bordered
                        size="large"
                        dataSource={SERVICES_LIST}
                        renderItem={item =>
                            <ServiceListItem
                                item={item}
                                onItemClick={this.onItemClick}
                                disabled={this.state.buttonClicked}
                            />
                        }
                    />
                </Col>
            </Row>
        );
    }
}

export default withFormHandler(FormStepService);
